import React, { useState } from 'react';
import { Train, Bus } from 'lucide-react';

import TrainReport from './reports/TrainReport';
import CoachReportsWrapper from './reports/CoachReportsWrapper';
import CityBusReports from './reports/CityBusReports';

export default function Reports({ onNavigateToPlanning }) {
  const [category, setCategory] = useState('Train');

  const tabs = [
    { id: 'Train', label: 'Train', icon: <Train className="w-4 h-4" />, color: 'blue' },
    { id: 'Coach', label: 'Coach', icon: <Bus className="w-4 h-4" />, color: 'orange' },
    { id: 'City Bus', label: 'City Bus', icon: <Bus className="w-4 h-4" />, color: 'green' },
  ];

  return (
    <div className="space-y-5 max-w-[1400px] mx-auto" data-testid="reports-page">
      {/* Category Tabs */}
      <div className="flex gap-1 bg-slate-100 rounded-xl p-1" data-testid="category-tabs">
        {tabs.map(tab => {
          const active = category === tab.id;
          const activeColors = { blue: 'bg-blue-600 text-white shadow-lg', orange: 'bg-orange-500 text-white shadow-lg', green: 'bg-green-600 text-white shadow-lg' };
          return (
            <button key={tab.id} onClick={() => setCategory(tab.id)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-lg text-xs font-semibold transition-all flex-1 justify-center
                ${active ? activeColors[tab.color] : 'text-slate-500 hover:text-slate-700 hover:bg-white/50'}`}
              data-testid={`tab-${tab.id.toLowerCase().replace(/\s/g, '-')}`}>
              {tab.icon}
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Content */}
      {category === 'Train' && <TrainReport />}
      {category === 'Coach' && <CoachReportsWrapper onNavigateToPlanning={onNavigateToPlanning} />}
      {category === 'City Bus' && <CityBusReports onNavigateToPlanning={onNavigateToPlanning} />}
    </div>
  );
}
